import {Injectable} from '@angular/core';
import {CardConfig, CardConfigPayload} from '../model/dcp-config-service/card-config';
import {Observable} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {DcpApiService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {

  constructor(private dcpApiService: DcpApiService) {
  }

  public getCardConfig(payload: CardConfigPayload): Observable<CardConfig> {
    const headers = this.getHeadersFromPayload(payload);
    return this.dcpApiService.callKyma<CardConfig>('config', 'cardConfig', {
      vendorId: payload.vendorId,
      salesOrgCode: payload.salesOrgCode
    }, {headers});
  }

  protected getHeadersFromPayload(payload: CardConfigPayload): HttpHeaders {
    let httpHeaders: HttpHeaders = new HttpHeaders({
      paymentMode: payload.httpParams.paymentMode,
      currency: payload.httpParams.currency,
      lineOfBusiness: payload.httpParams.lineOfBusiness,
      countryCode: payload.httpParams.countryCode,
      paymentProvider: payload.httpParams.paymentProvider
    });

    if (payload.httpParams.cardType) {
      httpHeaders = httpHeaders.set('cardType', payload.httpParams.cardType);
    }
    return httpHeaders;
  }
}
